import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import useFrontEndConfig from '../../../generic/hooks/useFrontEndConfig'
import { useAuthorization } from '../../../generic/hooks/useAuthorization'
import { useUncheckedAlarms } from '../../../generic/hooks/useUncheckedAlarms'
import AlarmsNotifications from '../AlarmsNotifications'
import { AUTOMATION_ALARMS_PERMISSION, initialAlarmSection } from '../alarmSections'

const Alarms = (props) => {
  const { toolbar, unChecked } = props
  const { t_ } = useSmartTranslation()
  // Story 162: the alarms are split into General alarms and Automation alarms. The installation decides which
  // one opens first, and the same rule serves the top-bar button and the maintenance screen, so both agree.
  const [config] = useFrontEndConfig()
  // The automation section has its own permission. Without it the view still asks for General alarms only
  // (the backend would otherwise send both), and there is nothing to switch to, so no tabs.
  const isUserAuthorized = useAuthorization()
  const canSeeAutomation = isUserAuthorized(AUTOMATION_ALARMS_PERMISSION)
  // Each tab carries its own pending count (HU-05), from the same summary the top bar polls.
  const { alarmsBySection } = useUncheckedAlarms()

  return (
    <AlarmsNotifications
      title={t_('Alarms')}
      state='ALARMS'
      unChecked={unChecked}
      toolbar={toolbar}
      splitBySection
      sections={canSeeAutomation}
      initialSection={initialAlarmSection(config, canSeeAutomation)}
      sectionCounts={alarmsBySection}
    />
  )
}
export default Alarms
